module.exports = __webpack_public_path__ + "img/6.a8bd598c.jpeg";